import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 640,
    margin: '0 auto',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    '& > p': {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.body1.fontSize,
    },
  },
  clipboardContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: `${theme.spacing(6)}px 0`,
    [theme.breakpoints.down('sm')]: {
      margin: `${theme.spacing(3)}px 0`,
    },
  },
  copyButton: {
    margin: `${theme.spacing(2)}px auto 0`,
  },
  body: {
    display: 'flex',
    width: '100%',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  bodyTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  qrCodeContainer: {
    margin: '0 auto',
    '& img': {
      maxWidth: 180,
      margin: -4,
    },
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  orderedList: {
    listStyleType: 'none',
    '& li': {
      marginBottom: theme.spacing(0.5),
      fontSize: theme.typography.body2.fontSize,
      '& span': {
        fontWeight: 'bold',
      },
    },
  },
  otherPaymentsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: `${theme.spacing(4)}px 0`,
    fontSize: theme.typography.body2.fontSize,
    [theme.breakpoints.down('sm')]: {
      margin: `${theme.spacing(3)}px 0`,
    },
  },
  errorIcon: {
    fontSize: 64,
    color: theme.palette.warning.main,
    marginBottom: theme.spacing(2),
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    margin: '0 auto',
    textAlign: 'center',
    minHeight: '70vh',
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: theme.spacing(2),
  },
  links: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > a': {
      color: theme.palette.text.primary,
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
  divider: {
    width: 2,
    backgroundColor: theme.palette.text.primary,
    minHeight: 14,
    margin: `-2px ${theme.spacing(1)}px 0`,
  },
  badgesContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    margin: `${theme.spacing(4)}px 0`,
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      margin: 0,
    },
  },
  badge: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  badgeTitle: {
    fontWeight: 600,
    fontSize: theme.typography.body2.fontSize,
    marginBottom: 2,
  },
  badgeSubtitle: {
    fontWeight: 400,
    fontSize: theme.typography.body2.fontSize,
  },
}));
